/* =============================================================================
 * Pinned cart-drawer upsells — Screen Protector + MagSafe cardholder
 * When an iPhone case is in the cart, pin (in order) at the START of
 * #cart-upsell-results:
 *   1) the matching-device screen protector, 2) the MagSafe cardholder,
 * ahead of the theme's "Complete the Look" recommendations.
 * Config (localized titles + variant data) comes from inline #gc-cart-pins
 * (no fetch). Robust to cart re-renders: watches a stable ancestor and keeps
 * the pinned cards at the front no matter how often the recommendations reload.
 * ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('gc-cart-pins');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
  var SP = CFG.screen_protector || null;   // device-matched
  var MS = CFG.magsafe || null;            // universal
  var ADD = CFG.add || 'Add';
  if (!SP && !MS) return;

  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase().replace(/\s+/g, ' '); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var fmt = (window.__cartI18n && window.__cartI18n.moneyFormat) || '${{amount}}';
    var a = (Number(cents) / 100).toFixed(2).replace(/\.00$/, ''); /* "$15", not "$15.00" (owner, 17 Oct 2026) */
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, a.replace(/\B(?=(\d{3})+(?!\d))/g, ',')) /* "$1,000", as Liquid prints it (Oct 2026) */
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.floor(Number(cents) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, a.replace('.', ','));
  }

  // Add via XHR to bypass personalize-drawer.js's window.fetch wrapper (see addon script).
  function cartAdd(payload) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () { (xhr.status >= 200 && xhr.status < 300) ? resolve(xhr.responseText ? JSON.parse(xhr.responseText) : {}) : reject(new Error('cart/add ' + xhr.status)); };
      xhr.onerror = function () { reject(new Error('network')); };
      xhr.send(JSON.stringify(payload));
    });
  }

  function getCart() {
    var p = null;
    if (window._gcGetCart) { try { p = Promise.resolve(window._gcGetCart()); } catch (e) { p = null; } }
    if (!p) p = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return p.then(function (c) { return (c && c.items) ? c : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); });
  }

  function lineValues(it) {
    if (it.options_with_values) return it.options_with_values.map(function (o) { return o.value; });
    if (it.variant_options) return it.variant_options;
    if (it.variant_title) return String(it.variant_title).split(' / ');
    return [];
  }

  function cardHTML(o) {
    var was = (o.compare_at && o.compare_at > o.price)
      ? ' <span class="Price Price--compareAt Text--subdued">' + money(o.compare_at) + '</span>' : '';
    return '<div class="gc-sp-cart-item" data-gc-sp-pin="' + o.key + '">' +
        '<div class="gc-sp-cart-view" data-gc-cart-view data-href="' + o.url + '?variant=' + o.variantId + '" role="button" tabindex="0" aria-label="' + escapeHtml(o.title) + '">' +
          '<span class="gc-sp-cart-img" style="background-image:url(\'' + o.image + '\')"></span>' +
          '<div class="cart-upsell-item-title">' + escapeHtml(o.title) + '</div>' +
          '<div class="cart-upsell-item-price"><span class="Price">' + money(o.price) + '</span>' + was + '</div>' +
        '</div>' +
        '<button type="button" class="gc-sp-cart-add" data-gc-cart-add data-variant="' + o.variantId + '">' + escapeHtml(ADD) + '</button>' +
      '</div>';
  }

  var state = { cards: [] };

  function build(cart) {
    var cards = [], items = cart.items || [], inCart = {};
    items.forEach(function (it) { inCart[it.variant_id] = true; });

    var hasIphone = false, supportedKey = null;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (SP && it.product_id === SP.id) continue;
      if (MS && it.product_id === MS.id) continue;
      var vals = lineValues(it);
      // "iPhone" is a brand name — present in the device option value in every language
      var hay = ((it.handle || '') + ' ' + (it.product_title || it.title || '') + ' ' + vals.join(' ')).toLowerCase();
      if (hay.indexOf('iphone') !== -1) hasIphone = true;
      if (SP && SP.variants && !supportedKey) {
        for (var j = 0; j < vals.length; j++) { var k = norm(vals[j]); if (SP.variants[k]) { supportedKey = k; break; } }
      }
    }

    // 1) screen protector (device-matched) — only for supported devices, if not already in cart
    if (SP && supportedKey) {
      var spv = SP.variants[supportedKey];
      if (spv && !inCart[spv.id]) {
        cards.push({ key: 'sp', html: cardHTML({ key: 'sp', url: SP.url, title: SP.title, image: spv.image, price: spv.price, compare_at: spv.compare_at, variantId: spv.id }) });
      }
    }
    // 2) MagSafe cardholder (universal) — whenever an iPhone case is in cart, if not already added
    if (MS && hasIphone && !inCart[MS.variant_id]) {
      cards.push({ key: 'ms', html: cardHTML({ key: 'ms', url: MS.url, title: MS.title, image: MS.image, price: MS.price, compare_at: MS.compare_at, variantId: MS.variant_id }) });
    }
    return cards;
  }

  function ensureInjected() {
    var results = document.querySelector('#cart-upsell-results');
    if (!results) return;
    var want = state.cards;
    var pins = results.querySelectorAll('[data-gc-sp-pin]');
    // already correct (same keys, same order, as the first children)? → no-op (prevents loops/flicker)
    var ok = pins.length === want.length;
    if (ok) {
      for (var i = 0; i < want.length; i++) {
        if (results.children[i] !== pins[i] || pins[i].getAttribute('data-gc-sp-pin') !== want[i].key) { ok = false; break; }
      }
    }
    if (ok) return;
    Array.prototype.forEach.call(pins, function (p) { p.remove(); });
    if (want.length) { results.insertAdjacentHTML('afterbegin', want.map(function (c) { return c.html; }).join('')); }
  }

  var recomputing = false;
  function recompute() {
    if (recomputing) return;
    recomputing = true;
    getCart()
      .then(function (cart) { state.cards = build(cart); ensureInjected(); })
      .catch(function () {})
      .then(function () { recomputing = false; });
  }

  // Watch a STABLE ancestor so node replacement on cart re-render can't orphan us.
  var debounce;
  function startObserver() {
    var root = document.querySelector('#sidebar-cart') || document.body;
    new MutationObserver(function () { clearTimeout(debounce); debounce = setTimeout(ensureInjected, 80); })
      .observe(root, { childList: true, subtree: true });
  }

  function navigate(el) { var href = el && el.getAttribute('data-href'); if (href) window.location.href = href; }

  // Delegated clicks (cards live in the drawer and are re-injected).
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-gc-cart-add]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-variant');
      if (!id || add.classList.contains('is-loading')) return;
      add.classList.add('is-loading'); add.disabled = true;
      cartAdd({ id: Number(id), quantity: 1 })
        .then(function () {
          if (window._gcInvalidateCart) { try { window._gcInvalidateCart(); } catch (e2) {} }
          if (window.refreshCartDrawer) { window.refreshCartDrawer(); }
          else { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
          setTimeout(recompute, 400);
          add.classList.remove('is-loading'); add.disabled = false;
        })
        .catch(function () { add.classList.remove('is-loading'); add.disabled = false; });
      return;
    }
    var view = e.target.closest('[data-gc-cart-view]');
    if (view) { e.preventDefault(); navigate(view); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var view = e.target.closest('[data-gc-cart-view]');
    if (view) { e.preventDefault(); navigate(view); }
  });

  document.addEventListener('cart:refresh', function () { setTimeout(recompute, 50); });
  document.addEventListener('product:added', function () { setTimeout(recompute, 50); });

  function init() {
    startObserver();
    recompute();
    var cart = document.querySelector('#sidebar-cart');
    if (cart) {
      new MutationObserver(function () { if (cart.getAttribute('aria-hidden') === 'false') recompute(); })
        .observe(cart, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
